// 导入所有 phone 模块的国际化文件
import { messages as communityRecommendMessages } from '@/lang/phone/communityRecommendLang.js'
import { messages as indexMenuMessages } from '@/lang/phone/indexMenuLang.js'

// 合并所有国际化消息
export const messages = {
    en: {
        ...communityRecommendMessages.en,
        ...indexMenuMessages.en
    },
    zh: {
        ...communityRecommendMessages.zh,
        ...indexMenuMessages.zh
    }
} 